import React, { FC, useState, useEffect, memo, useCallback } from "../../../lib/teact/teact";
import type { ChangeEvent } from 'react';
import './lotCheckBox.scss'
import buildClassName from "../../../util/buildClassName";
type OwerProps = {
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    checked?: boolean;
    text?: string;
    subText?:string;
    value?: string;
    disabled?: boolean;
}

const LotCheckbox: FC<OwerProps> = ({
    onChange,
    checked,
    text,
    value,
    subText,
    disabled
}) => {
    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(event);
        }
        console.log(`lotCheckBox handleChange input() value=${value}`)
    }, [onChange]);
    function handleLabelClick(event: React.MouseEvent) {
        //console.log(`lotCheckBox handleLabelClick()`)
        //event.stopPropagation();
    }
    function handleInputCheckBoxClick(event: React.MouseEvent) {
        //console.log(`lotCheckBox handleInputCheckBoxClick()`)
        event.stopPropagation(); // top vì sự kiện đã được nhận ở label rồi
    }
    const labelClassName = buildClassName(
         'Checkbox',
        'lot-check-box',
        // disabled && 'disabled',
        // round && 'round',
        // isLoading && 'loading',
        // blocking && 'blocking',
        // className,
      );
    return (
        <label className="LotCheckbox"
            onClick={handleLabelClick}
        >
            <input type="checkbox" value={value} 
                checked={checked}
                onChange={handleChange}
                onClick={handleInputCheckBoxClick}
                disabled={disabled}
            ></input>
            <div className="Checkbox-main">{text}</div>
        </label>
    )
}
export default memo(LotCheckbox)